export default "__VITE_ASSET__rfNLm3mL__"